import { Directive, Input, OnChanges } from '@angular/core';
import { NavigationHistoryService } from '../services/navigation-history.service';

@Directive({ selector: '[appBreadcrumbLabel]' })
export class BreadcrumbLabelDirective implements OnChanges {
	constructor(private readonly navHistory: NavigationHistoryService) {}

	@Input() appBreadcrumbLabel!: string;
	private lastAppliedLabel = '';

	ngOnChanges(): void {
		const label = this.appBreadcrumbLabel?.trim();
		if (!label || label === this.lastAppliedLabel) {
			return;
		}

		Promise.resolve().then(() => {
			if (this.appBreadcrumbLabel?.trim() !== label) {
				return;
			}

			if (label === this.lastAppliedLabel) {
				return;
			}

			this.lastAppliedLabel = label;
			this.navHistory.setLastNavigationLabel(label, true);
		});
	}
}
